import { useState, useEffect } from 'react'
import api, { IEmployeeImport } from '@api'

export default function useActiveImport() {
  const [loading, setLoading] = useState(true)
  const [activeImport, setActiveImport] = useState<IEmployeeImport | null>(null)

  useEffect(() => {
    api.employee.import.active().then((activeImport) => {
      setLoading(false)
      setActiveImport(activeImport || null)
    })
  }, [])

  return { loading, activeImport }
}
